import { render, staticRenderFns } from "./BtDashboardSave.vue?vue&type=template&id=fd4e1254&scoped=true&"
import script from "./BtDashboardSave.vue?vue&type=script&lang=js&"
export * from "./BtDashboardSave.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardSave.vue?vue&type=style&index=0&id=fd4e1254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4e1254",
  null
  
)

export default component.exports